if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class AddToCart extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form[action$="/cart/add"]');
        this.productIdInput = this.form.querySelector("[name=id]");
        this.productIdInput.disabled = false; // Повернуто з оригіналу
        this.submitBtn = this.querySelector('button[name="add"]');
        this.form.addEventListener("submit", this.formSubmit.bind(this));
      }

      formSubmit(evt) {
        evt.preventDefault();
        const soldOutWrapper = document.querySelector(
          ".wrapper__sold-out-info"
        );
        const emailInput = document.querySelector(
          'input[name="sold_out_email"]'
        );

        let isSoldOutMode = false;
        if (
          soldOutWrapper &&
          emailInput &&
          window.getComputedStyle(soldOutWrapper).display !== "none"
        ) {
          isSoldOutMode = true;
        }

        if (isSoldOutMode) {
          this.submitToKlaviyoNewApi(emailInput.value);
        } else {
          this.addToCart();
        }
      }

      submitToKlaviyoNewApi(email) {
        const variantId = this.productIdInput.value;

        const currentBtn = this.querySelector('button[name="add"]');
        const apiKey = currentBtn
          ? currentBtn.getAttribute("data-klaviyo-key")
          : null;
        const listId = currentBtn
          ? currentBtn.getAttribute("data-list-id")
          : "Ych7mk";
        const productTitle = currentBtn
          ? currentBtn.getAttribute("data-product-title")
          : "Unknown Product";

        if (!apiKey || apiKey.includes("YOUR_PUBLIC")) {
          console.error(
            "Add your Klaviyo Key to the button data-klaviyo-key attribute"
          );
          return;
        }

        if (!email || !email.includes("@")) {
          this.variantError("Please enter a valid email address.");
          const emailInputEl = document.querySelector(
            'input[name="sold_out_email"]'
          );
          if (emailInputEl) {
            emailInputEl.value = "";
          }
          return;
        }

        if (currentBtn) currentBtn.classList.add("loading");

        const requestData = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                    properties: {
                      [variantId]: productTitle,
                    },
                  },
                },
              },
              custom_source: "back in stock",
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId,
                },
              },
            },
          },
        };

        const requestConfig = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15",
          },
          body: JSON.stringify(requestData),
        };

        fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${apiKey}`,
          requestConfig
        )
          .then((response) => {
            if (response.ok) {
              const soldOutWrapper = document.querySelector(
                ".wrapper__sold-out-info"
              );
              if (soldOutWrapper) {
                const emailInputEl = document.querySelector(
                  'input[name="sold_out_email"]'
                );
                if (emailInputEl) {
                  emailInputEl.style.display = "none";
                }

                const btnToHide = this.querySelector('button[name="add"]');
                if (btnToHide) {
                  btnToHide.style.setProperty("display", "none", "important");
                }

                const soldOutText =
                  soldOutWrapper.querySelector(".sold-out__text");
                if (soldOutText) {
                  soldOutText.innerText =
                    "We'll notify you when this item is back in stock!";
                }
              }
            } else {
              return response.json().then((err) => {
                throw new Error(
                  err.errors && err.errors[0]
                    ? err.errors[0].detail
                    : "Error subscribing"
                );
              });
            }
          })
          .catch((error) => {
            console.error(error);
            this.variantError(
              "Something went wrong or you are already subscribed."
            );
          })
          .finally(() => {
            const btn = this.querySelector('button[name="add"]');
            if (btn) btn.classList.remove("loading");
          });
      }

      addToCart() {
        if (this.productIdInput.value == "") {
          this.variantError();
          return;
        }

        if (this.querySelector(".error-message")) {
          this.querySelector(".error-message").remove();
        }
        this.removeErrorsBlock();

        this.querySelector('button[name="add"]').classList.add("loading");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.errorMessage(response);
              return;
            }
            this.succses();
          })
          .catch((error) => {
            console.log(error);
            this.querySelector('button[name="add"]').classList.remove(
              "loading"
            );
          });
      }

      errorMessage(resp) {
        console.log(resp.description);
        this.errorPopup(resp.description);
        this.querySelector('button[name="add"]').classList.remove("loading");
      }

      succses() {
        console.log("Success");
        this.querySelector('button[name="add"]').classList.remove("loading");

        if (typeof updateCartCount === "function") updateCartCount();
        if (typeof updateCartNotification === "function")
          updateCartNotification(this.productIdInput.value);
      }

      variantError(text = null) {
        this.errorPopup(text || window.translation.variant_error);
      }

      removeErrorsBlock() {}

      errorPopup(text) {
        let alertPopup = document.querySelector(".js-productAlert-modal");
        const bodyEl = document.querySelector("html");
        if (alertPopup) {
          if (alertPopup.querySelector("[data-error-text]"))
            alertPopup.querySelector("[data-error-text]").innerHTML = text;

          if (!alertPopup.classList.contains("show")) {
            bodyEl.classList.add("show-modal");
            document
              .querySelectorAll(".wrapper-modal")
              .forEach((m) => m.classList.remove("show"));
            alertPopup.classList.add("show");
            if (alertPopup.classList.contains("modal-overlay"))
              bodyEl.classList.add("show-modal-overlay");
          }
        } else {
          alert(text);
        }
      }
    }
  );
}
